"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import { useLocationsGet } from "@/features/locations/hooks";
import {
  resolvePublicLocationsNavLink,
  type PublicLocationsNavLink,
} from "@/lib/utils/locationsPublic";

const PublicLocationsNavContext = createContext<
  PublicLocationsNavLink | null | undefined
>(undefined);

export function PublicLocationsNavProvider({
  value,
  children,
}: {
  value: PublicLocationsNavLink | null | undefined;
  children: ReactNode;
}) {
  return (
    <PublicLocationsNavContext.Provider value={value}>
      {children}
    </PublicLocationsNavContext.Provider>
  );
}

export function usePublicLocationsNavLink(): PublicLocationsNavLink | null {
  const provided = useContext(PublicLocationsNavContext);
  const { data } = useLocationsGet({ enabled: provided === undefined });

  return useMemo(() => {
    if (provided !== undefined) return provided;
    return resolvePublicLocationsNavLink(data?.items);
  }, [provided, data?.items]);
}
